<template lang="">
  <div>
    <PositionGuid :posGuids="posGuids"></PositionGuid>
    <div class="lists bg-white gWidth  padding">
      <div>
        <LeftNav
          :leftlists="leftlists"
          :currentIndex="currentIndex"
          :no_link="false"
          @rightlist2="rightlist2"
        ></LeftNav>
      </div>
      <div class="news_r padding-bottom">
        <span class="right_tit" v-if="currentIndex == 0">留言列表</span>
        <span class="right_tit" v-else-if="currentIndex == 1">公众留言</span>
        <span class="right_tit" v-else-if="currentIndex == 2">留言统计</span>
        <div>
          <keep-alive :include="['MessageLists', 'LeaveMessage', 'Statistics']"
            ><router-view></router-view>
          </keep-alive>
        </div>
        <div>
          <!-- #region -->

          <!-- #endregion -->
        </div>
        <!-- 留言提交 -->

        <!-- 提交结束 -->
        <!-- 留言统计 -->

        <!-- 留言统计结束 -->
      </div>
    </div>
  </div>
</template>
<script>
// import { leftlist } from "@/api/gxq";
import LeftNav from "../../components/LeftNav/LeftNav";

import PositionGuid from "../../components/PositionGuid/PositionGuid";
export default {
  name: "Gzly",
  components: {
    LeftNav,
    PositionGuid,
  },
  data() {
    return {
      posGuids: [
        {
          title: "留言列表",
          link: "",
        },
      ],
      leftlists: [],
      isLb: true,
      currentIndex: 0,
      id: 30,
    };
  },
  mounted() {
    this.leftlist2();
  },
  methods: {
    async leftlist2() {
      // var data3 = await leftlist({
      //   id: this.id,
      // });
      this.leftlists = [
        {
          id: 55,
          name: "留言列表",
          link: "/Gzly/MessageLists",
        },
        {
          id: 54,
          name: "公众留言",
          link: "/Gzly/LeaveMessage",
        },
        {
          id: 117,
          name: "留言统计",
          link: "/Gzly/Statistics",
        },
      ];
    },

    rightlist2({ index }) {
      this.currentIndex = index;

      //   console.log("------------测试", this.currentIndex);
      if (index == 0) {
        this.isLb = true;
        this.posGuids = [
          {
            title: "留言列表",
            link: "",
          },
        ];
      } else if (index == 1) {
        this.isLb = false;
        this.posGuids = [
          {
            title: "公众留言",
            link: "",
          },
        ];
      } else if (index == 2) {
        this.isLb = false;
        this.posGuids = [
          {
            title: "留言统计",
            link: "",
          },
        ];
      }
    },
  },
};
</script>

<style src="../../../vab/styles/gaikuang/gaikuang_big.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_mid.css" scoped></style>
<style src="../../../vab/styles/gaikuang/gaikuang_small.css" scoped></style>
